<template>
  <div class="vote-question">
    <div class="vote-question-title">
      <div>
        <span>{{ question.num}}.</span>
      </div>
      <div>
        <div v-html="question.content.richText"></div>
      </div>
    </div>
    <div>
      <vote-content :question="question"/>
    </div>
  </div>
</template>

<script>
import VoteContent from './Content'
export default {
  name: 'VoteQuestion',
  components:{VoteContent},
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    console.log("12312")
  }
}
</script>
